var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bubble text-body-2 font-weight-medium d-flex align-center justify-center",class:_vm.classes},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.label)+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }